<template>
  <div>
    <!-- 预定统计 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>活动管理</el-breadcrumb-item>
      <el-breadcrumb-item>活动列表</el-breadcrumb-item>
      <el-breadcrumb-item>活动详情</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="tab">
      <span
        v-for="(v,i) in tabBtn"
        :key="v.id"
        @click="tabTitle(i)"
        :class="activeIndex==i?'activeTab':''"
      >{{v.name}}</span>
    </div>
    <el-card>
      <!-- 预定统计 -->
      <div v-if="activeIndex==0">
        <div class="titleSear">
          <el-date-picker
            v-model="value1"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
          <el-button>查询</el-button>
        </div>
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          style="width: 100%"
        >
          <el-table-column label="排序" type="index"></el-table-column>
          <el-table-column prop="name" label="时间"></el-table-column>
          <el-table-column prop="name" label="总销售额"></el-table-column>
        </el-table>
        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共几条记录，</span>
          <span class="demonstration">当前显示第几页</span>
          <el-pagination background layout="prev, pager, next" :total="1000"></el-pagination>
        </div>
        <!-- 分页结束 -->
      </div>
      <!-- 消费统计 -->
      <div v-if="activeIndex==1">
        <el-row class="conentRow">
          <el-date-picker
            v-model="value1"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
          <el-select v-model="value" clearable placeholder="全部分销商">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-button class="conentBtn" type="primary">查询</el-button>
        </el-row>
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          style="width: 100%"
        >
          <el-table-column label="ID" type="index"></el-table-column>
          <el-table-column prop="name" label="日期"></el-table-column>
          <el-table-column prop="address" label="分销商名称"></el-table-column>
          <el-table-column prop="address" label="消费金额"></el-table-column>
          <el-table-column prop="address" label="消费数量"></el-table-column>
          <el-table-column prop="address" label="操作">
            <template slot-scope="scope">
              <!-- 没有设计图 -->
              <el-button type="text" @click="xftjDetailFn(scope.row)">明细</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共几条记录，</span>
          <span class="demonstration">当前显示第几页</span>
          <el-pagination background layout="prev, pager, next" :total="1000"></el-pagination>
        </div>
        <!-- 分页结束 -->
      </div>
      <!-- 消费统计结束 -->
      <!-- 退票统计开始 -->
      <div v-if="activeIndex==2">
        <el-row class="conentRow">
          <el-date-picker
            v-model="value1"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
          <el-select v-model="value" clearable placeholder="全部分销商">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-button class="conentBtn" type="primary">查询</el-button>
        </el-row>
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          style="width: 100%"
        >
          <el-table-column label="序号" type="index"></el-table-column>
          <el-table-column prop="name" label="日期"></el-table-column>
          <el-table-column prop="address" label="分销商名称"></el-table-column>
          <el-table-column prop="address" label="退票数量"></el-table-column>
          <el-table-column prop="address" label="退票金额"></el-table-column>
          <el-table-column prop="address" label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="detailTickFn(scope.row)">明细</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共几条记录，</span>
          <span class="demonstration">当前显示第几页</span>
          <el-pagination background layout="prev, pager, next" :total="1000"></el-pagination>
        </div>
        <!-- 分页结束 -->
      </div>
      <!-- 退票统计结束 -->
      <!-- 预定记录开始 -->
      <div v-if="activeIndex==3">
        <el-row class="conentRow">
          <el-input placeholder="手机号/订单号"></el-input>
          <el-date-picker
            v-model="value1"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
          <el-select v-model="value" clearable placeholder="全部分销商">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select v-model="value" clearable placeholder="验票查询">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-button class="conentBtn" type="primary">查询</el-button>
        </el-row>
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          style="width: 100%"
        >
          <el-table-column label="序号" type="index"></el-table-column>
          <el-table-column prop="name" label="订单号"></el-table-column>
          <el-table-column prop="address" label="分销商"></el-table-column>
          <el-table-column prop="address" label="验证码"></el-table-column>
          <el-table-column prop="address" label="手机号"></el-table-column>
          <el-table-column prop="address" label="状态"></el-table-column>
          <el-table-column prop="address" label="下单时间"></el-table-column>
          <el-table-column prop="address" label="金额"></el-table-column>
          <el-table-column prop="address" label="购买数量"></el-table-column>
          <el-table-column prop="address" label="验票数量"></el-table-column>
          <el-table-column prop="address" label="退票数量"></el-table-column>
        </el-table>
        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共几条记录，</span>
          <span class="demonstration">当前显示第几页</span>
          <el-pagination background layout="prev, pager, next" :total="1000"></el-pagination>
        </div>
        <!-- 分页结束 -->
      </div>
      <!-- 预定记录结束 -->
      <!-- 消费记录开始 -->
      <div v-if="activeIndex==4">
        <el-row class="conentRow">
          <el-input placeholder="请输入订单号"></el-input>
          <el-date-picker
            v-model="value1"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
          <el-select v-model="value" clearable placeholder="全部分销商">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select v-model="value" clearable placeholder="全部产品">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-button class="conentBtn" type="primary">查询</el-button>
        </el-row>
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          style="width: 100%"
        >
          <el-table-column label="序号" type="index"></el-table-column>
          <el-table-column prop="name" label="分销商名称"></el-table-column>
          <el-table-column prop="address" label="订单号"></el-table-column>
          <el-table-column prop="address" label="金额"></el-table-column>
          <el-table-column prop="address" label="产品名称"></el-table-column>
          <el-table-column prop="address" label="验票时间"></el-table-column>
        </el-table>
        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共几条记录，</span>
          <span class="demonstration">当前显示第几页</span>
          <el-pagination background layout="prev, pager, next" :total="1000"></el-pagination>
        </div>
        <!-- 分页结束 -->
      </div>
      <!-- 消费记录结束 -->
      <!-- 退票记录开始 -->
      <div v-if="activeIndex==5">
        <el-row class="conentRow">
          <el-date-picker
            v-model="value1"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
          <el-select v-model="value" clearable placeholder="全部分销商">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select v-model="value" clearable placeholder="全部产品">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-button class="conentBtn" type="primary">查询</el-button>
        </el-row>
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          style="width: 100%"
        >
          <el-table-column label="序号" type="index"></el-table-column>
          <el-table-column prop="name" label="分销商名称"></el-table-column>
          <el-table-column prop="address" label="订单号"></el-table-column>
          <el-table-column prop="address" label="退票金额"></el-table-column>
          <el-table-column prop="address" label="产品名称"></el-table-column>
          <el-table-column prop="address" label="退票时间"></el-table-column>
        </el-table>
        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共几条记录，</span>
          <span class="demonstration">当前显示第几页</span>
          <el-pagination background layout="prev, pager, next" :total="1000"></el-pagination>
        </div>
        <!-- 分页结束 -->
      </div>
      <!-- 退票记录结束 -->
    </el-card>
    <!-- 销售统计查看详情开始 -->
    <directStaDialog v-if="xstjinfovisible" ref="xstjinfoDialog"></directStaDialog>
    <!-- 销售统计查看详情结束 -->
    <!-- 消费统计明细开始 -->
    <directStaDialog v-if="detailvisible" ref="detailDialog"></directStaDialog>
    <!-- 消费统计明细结束 -->
    <!-- 退票统计明细开始 -->
    <directStaDialog v-if="refundTicketvisible" ref="refundTicketDialog"></directStaDialog>
    <!-- 退票统计明细结束 -->
  </div>
</template>

<script>
import directStaDialog from "./dialog/directStaDialog.vue";
export default {
  components: {
    directStaDialog
  },
  data() {
    return {
      xstjinfovisible: false, // 销售统计查看详情
      detailvisible: false, // 消费统计明细
      refundTicketvisible: false, // 退票统计明细
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "57674"
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "2464634"
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "43434"
        },
        {
          date: "2016-05-03",
          name: "王小虎",
          address: "1345"
        }
      ],
      tabBtn: [
        {
          id: 1,
          name: "预定统计"
        },
        {
          id: 2,
          name: "消费统计"
        },
        {
          id: 3,
          name: "退票统计"
        },
        {
          id: 4,
          name: "预定记录"
        },
        {
          id: 5,
          name: "消费记录"
        },
        {
          id: 6,
          name: "退票记录"
        }
      ],
      upOption: [
        {
          id: 1,
          value: "是"
        },
        {
          id: 2,
          value: "否"
        }
      ],
      value: "",
      activeIndex: "", // 选中tab
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      value1: "",
      options: [
        {
          value: "选项1",
          label: "黄金糕"
        },
        {
          value: "选项2",
          label: "双皮奶"
        },
        {
          value: "选项3",
          label: "蚵仔煎"
        },
        {
          value: "选项4",
          label: "龙须面"
        },
        {
          value: "选项5",
          label: "北京烤鸭"
        }
      ],
      value: ""
    };
  },
  methods: {
    // 退票统计明细
    detailTickFn(row) {
      this.refundTicketvisible = true;
      this.$nextTick(() => {
        this.$refs.refundTicketDialog.detailTick(row);
      });
    },
    // 消费统计明细
    xftjDetailFn(row) {
      this.detailvisible = true;
      this.$nextTick(() => {
        this.$refs.detailDialog.Detail(row);
      });
    },
    // 销售统计查看详情
    seeInfoFn(row) {
      this.xstjinfovisible = true;
      this.$nextTick(() => {
        this.$refs.xstjinfoDialog.seeInfo(row);
      });
    },
    tabTitle(index) {
      // console.log(index);
      this.activeIndex = index;
      console.log(this.activeIndex);
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang='less' scoped>
.titleSear {
  margin-bottom: 20px;
  .el-input {
    width: 300px;
  }
  .el-button {
    width: 100px;
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    border: none;
    margin-left: 20px;
  }
}
.conentRow {
  display: flex;
  margin-bottom: 20px;
  .el-date-editor {
    margin-right: 20px;
  }
  .el-input {
    width: 250px;
    margin-right: 20px;
  }
  .el-select {
    width: 220px;
    margin-right: 20px;
  }
  .conentBtn {
    width: 100px;
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    border: none;
    color: #ffffff;
    border: none;
    margin-right: 10px;
  }
  .conentBtn2 {
    background: #ffffff;
    border: 1px solid #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #246deb;
    box-sizing: border-box;
  }
}

.qxsq {
  // 分页
  .pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 32px;
    margin: 30px auto 20px;
    span {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
    }
  }
}

.tab {
  display: flex;
  margin: 20px 0;
  .activeTab {
    background: #246deb;
  }
  span {
    width: 120px;
    height: 40px;
    display: block;
    border-radius: 0px 0px 4px 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 40px;
    color: #ffffff;
    border: none;
    text-align: center;
    background: #d9d9d9;
    margin-right: 20px;
  }
}
// /deep/.el-dialog__header {
//   height: 60px;
//   line-height: 60px;
//   padding: 0;
// }

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 45px auto 40px;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}
</style>